export default __webpack_public_path__ + "static/media/mustard_spray.c3f9f87c.gif";